import request from '../helpers/request';

const getWorkerPhone = async (workerId) => {
  return await request.get(
    `/Phone/get_phone`,
    { workerId },
    `При получении номера телефона произошла ошибка`
  );
};

export default getWorkerPhone;
